import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { SessionInvalidDialogComponent } from '@shared/components/dialogs/session-invalid-dialog/session-invalid-dialog.component';
import { APPLICATION_AUTH_REQUEST } from './application-auth.context';
import { PAYMENTS_ENDPOINTS } from '@shared/constants/payments-endpoints.constant';
import { getRejectedPaymentMethod } from '@payments/utils/payment-method-policy-error';

const PAYROC_PAYMENT_ENDPOINTS: readonly string[] = [
  PAYMENTS_ENDPOINTS.payroc.hostedFieldsSession,
  PAYMENTS_ENDPOINTS.payroc.pay,
];

function isPaymentMethodPolicyRejection(request: HttpRequest<unknown>, error: HttpErrorResponse): boolean {
  if (request.method !== 'POST' || !getRejectedPaymentMethod(error)) return false;

  try {
    return PAYROC_PAYMENT_ENDPOINTS.includes(new URL(request.url, 'http://localhost').pathname);
  } catch {
    return false;
  }
}

/**
 * HTTP interceptor that handles common HTTP errors globally.
 * - 401: Shows a session dialog, except for login and application-auth requests.
 * - 500: Server error (TODO: handle better)
 * Errors except expected Payroc payment-method rejections are logged.
 * All errors are re-thrown so services can still handle them if needed.
 */
export const errorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const dialog = inject(MatDialog);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (!isPaymentMethodPolicyRejection(request, error)) {
        console.error(`Backend returned code ${error.status}, body was:`, error.error);
      }

      // Login and application-auth failures do not indicate an invalid user session.
      const isLoginRequest = request.url.includes('login');

      if (error.status === 401 && !isLoginRequest && !request.context.get(APPLICATION_AUTH_REQUEST)) {
        SessionInvalidDialogComponent.open(dialog);
      }

      if (error.status === 500) {
        // TODO: Handle 500 errors better (show user-friendly message, retry logic, etc.)
        console.log('ITS A 500');
      }

      return throwError(() => error);
    }),
  );
};
